var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-item-header',{staticClass:"pc-note__note-details-header",attrs:{"name":"noteDetails"}},[_vm._v("笔记详情")])}
var staticRenderFns = []

export { render, staticRenderFns }